import { render, staticRenderFns } from "./TradeTransferConcepts.vue?vue&type=template&id=5bf63318&scoped=true&"
import script from "./TradeTransferConcepts.vue?vue&type=script&lang=js&"
export * from "./TradeTransferConcepts.vue?vue&type=script&lang=js&"
import style0 from "./TradeTransferConcepts.vue?vue&type=style&index=0&id=5bf63318&scoped=true&lang=css&"
import style1 from "./TradeTransferConcepts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf63318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bf63318')) {
      api.createRecord('5bf63318', component.options)
    } else {
      api.reload('5bf63318', component.options)
    }
    module.hot.accept("./TradeTransferConcepts.vue?vue&type=template&id=5bf63318&scoped=true&", function () {
      api.rerender('5bf63318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Complements/TradeTransferConcepts.vue"
export default component.exports